import { Action, Dispatch } from "redux";
import axios from "../../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../../config/constants";
import * as action_types from "./constants";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getTakeoffById = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getTakeoffById/${id}`);
      dispatch({
        type: action_types.TAKE_OFF_LISTING,
        data: { payload: data?.data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.TAKE_OFF_LISTING,
        data: { loading: false },
      });
    }
  };
};

export const removeTakeoffListingData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.TAKE_OFF_LISTING,
      data: { payload: {}, loading: true },
    });
  };
};

export const getUnitsFormData = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    const { data } = await axios.get(`${baseURL}getUnitsFormData/${id}`);
    dispatch({
      type: action_types.UNIT_FORM_DATA,
      data,
    });
  };
};
